import React from 'react'

const Logout = ({ onLogout }) => {
    localStorage.clear();
    sessionStorage.clear()
    onLogout();
    return (
        <div>Logout</div>
    )
}

export default Logout